import { render, staticRenderFns } from "./EmailBodyNavLink.vue?vue&type=template&id=8ddba694"
import script from "./EmailBodyNavLink.vue?vue&type=script&lang=js"
export * from "./EmailBodyNavLink.vue?vue&type=script&lang=js"
import style0 from "./EmailBodyNavLink.vue?vue&type=style&index=0&id=8ddba694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports